module.exports = __webpack_public_path__ + "img/goods.c2ef8e13.png";